var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.500488,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#E6E8F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5658 16.9797L16.9942 21.5514C16.3058 22.2397 16.3058 23.3564 16.9942 24.0447V24.0447C17.6825 24.7331 18.7992 24.7331 19.4875 24.0447L25.5142 18.0181C26.7767 16.7556 26.7767 14.7089 25.5142 13.4464V13.4464C24.2517 12.1839 22.205 12.1839 20.9425 13.4464L14.9158 19.4731C13.0792 21.3097 13.0792 24.2864 14.9158 26.1231V26.1231C16.7525 27.9597 19.7292 27.9597 21.5658 26.1231L25.2233 22.4656",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedPin);
export default __webpack_public_path__ + "static/media/RoundedPin.28dc3a19e69ecb4976ff37ac41db0bd3.svg";
export { ForwardRef as ReactComponent };